import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {TitleCasePipe} from "@angular/common";

import {TranslateService} from "@ngx-translate/core";

import {LinkViewModel} from '@data-sharing/view-models/link-view-model';

@Component({
  selector: 'dsm-added-link-modal',
  templateUrl: './added-link-modal.component.html',
})
export class AddedLinkModalComponent implements OnInit {

  private alwaysTrans = '';
  private fromTrans = '';
  private toTrans = '';
  private line1 = '';
  private line2 = '';
  private line3 = '';

  constructor(
    @Inject(MAT_DIALOG_DATA) public model: LinkViewModel,
    private matDialogRef: MatDialogRef<AddedLinkModalComponent>,
    private translateService: TranslateService
  ) {
    this.setTranslations();
  }

  ngOnInit(): void {
  }

  allDataAsText(): string {
    const vehicles = this.model.fullVehicles.map(x => x.Nm).join('\n');
    const validTo = this.model.link.endDate ?
      `${this.fromTrans} ${this.model.link.startDate} ${this.toTrans} ${this.model.link.endDate}` :
      this.alwaysTrans;

    const text =
      this.line1 +
      '\n' +
      this.model.url + '\n' +
      '\n' +
      this.line2 + ` ${validTo}` + '\n' +
      '\n' +
      this.line3 + '\n' +
      '\n' +
      vehicles;

    return text;
  }

  onClose() {
    this.matDialogRef.close();
  }

  private setTranslations() {
    this.translateService.get('labels.always').subscribe(x => this.alwaysTrans = new TitleCasePipe().transform(x));
    this.translateService.get('labels.from').subscribe(x => this.fromTrans = new TitleCasePipe().transform(x));
    this.translateService.get('labels.to').subscribe(x => this.toTrans = new TitleCasePipe().transform(x));
    this.translateService.get('data-sharing.clipboard-line1').subscribe(x => this.line1 = x);
    this.translateService.get('data-sharing.clipboard-line2').subscribe(x => this.line2 = x);
    this.translateService.get('data-sharing.clipboard-line3').subscribe(x => this.line3 = x);
  }

}
